<template>
  <div class="w-fit">
    <input
      :id="id"
      v-model="selectedRadio"
      :class="inputClass"
      type="radio"
      tabindex="0"
      :name="groupName"
      :value="value"
      @change="handleChange"
    />
    <label :for="id" :class="labelClass">
      <span class="flex flex-col items-start justify-center text-text-primary">
        <span>{{ label }}</span>
        <span v-if="secondaryLabel">{{ secondaryLabel }}</span>
      </span>
    </label>
  </div>
</template>

<script lang="ts" setup>
const id = useId();

interface Props {
  label?: string;
  secondaryLabel?: string;
  value?: string | {};
  groupName?: string;
  validateOnValueUpdate?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  label: '',
  secondaryLabel: undefined,
  value: '',
  groupName: 'radioknappar',
  validateOnValueUpdate: true,
});

const selectedRadio = defineModel<string | {}>();

const { handleChange } = useField(toRef(props, 'groupName'), undefined, {
  initialValue: selectedRadio,
  validateOnValueUpdate: props.validateOnValueUpdate,
});

const inputClass = `
  appearance-none
  overflow-hidden
  absolute
  peer
  focus-visible:outline-none
  `;

const labelClass = `
  relative
  cursor-pointer
  flex
  items-center
  gap-12
  w-fit
  text-16-22
  md:text-18-22
  lg:text-20-24


  before:border-border-primary
  before:border-solid
  before:border-2
  before:h-28
  before:w-28
  before:rounded-full
  before:shadow-input
  before:bg-surface-action-2
  before:hover:bg-surface-action-hover
  before:hover:transition-all
  before:hover:duration-200
  before:hover:ease-in
  before:peer-checked:bg-surface-success

  after:absolute
  after:w-16
  after:h-16
  after:rounded-full
  after:left-7
  after:peer-checked:bg-icon-secondary
  after:peer-checked:hover:w-6
  after:peer-checked:hover:h-6
  after:peer-checked:hover:left-12
  `;
</script>

<style scoped lang="scss">
input {
  &:focus + label {
    @apply outline outline-2 outline-border-highlight outline-offset-input;
  }
}
</style>
